import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { useNostrPublish } from '@/hooks/useNostrPublish';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { ScryfallCard } from '@/types/scryfall';
import { useScryfallCard } from '@/hooks/useScryfall';
import { NostrEvent } from '@nostrify/nostrify';

interface ShareCardDialogProps {
  card: ScryfallCard;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ShareCardDialog({ card, open, onOpenChange }: ShareCardDialogProps) {
  const { data: fullCard } = useScryfallCard(card.id, open);
  const [note, setNote] = useState('');
  const { mutate: createEvent, isPending } = useNostrPublish();


  useEffect(() => {
    if (open) {
      setNote('');
    }
  }, [open]);
  const { user } = useCurrentUser();



  const handleShare = () => {
    if (!user) return;

    const cardImage = fullCard?.card_faces?.[0]?.image_uris?.png ?? fullCard?.image_uris?.png;
    const content = `${note}${note ? '\n\n' : ''}${cardImage}`;

    const event: Partial<NostrEvent> = {
      kind: 1,
      content,
      tags: [],
    };

    createEvent(event, {
      onSuccess: () => {
        onOpenChange(false);
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share {card.name} to Nostr</DialogTitle>
        </DialogHeader>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Write an optional note..."
          rows={4}
        />
        <DialogFooter className="sm:justify-center">
          <Button onClick={handleShare} disabled={!user || isPending}>
            {isPending ? 'Sharing...' : 'Share'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
